import { call } from 'redux-saga/effects';
import { AnyFunction } from 'types';
import { Action } from './createAction';

export function* prepareArgs<A extends Action<string>>(requestArgsBuilder: AnyFunction, action: A) {
  let args = [];
  if (requestArgsBuilder) args = yield call(requestArgsBuilder, action);
  return Array.isArray(args) ? args : [args];
}
